/* Imports */
import {
  h,
  resolveComponent,
} from 'vue';
import FilterableArchive from '../containers/FilterableArchive.vue';

const subdirectory = window?.appData?.subdirectory ?? 'm';

export default [{
  path: `/:locale/${subdirectory}`,
  component: {
    render() {
      return h(resolveComponent('router-view'));
    },
  },
  children: [
    {
      path: 'health-studies',
      name: 'FilterableArchive',
      component: FilterableArchive,
    },
  ],
}];
